import PropTypes from 'prop-types';

import { FileBanner } from '@agilemd/ui-file-banner';

import getUrl from '../utils/getUrl.js';
import Feedback from './Common/Feedback.jsx';

const Banner = ({
  backUrl: backUrlFromProps,
  isPublic,
  baseUrl,
  feedbackCategories,
  feedbackPrompt,
  iconUrl,
  subtitle,
  title
}) => {
  const backUrl = getUrl(backUrlFromProps, { excludeBaseUrl: true });

  return (
    <FileBanner
      moduleArt={iconUrl}
      fileTitle={title}
      fileSubtitle={subtitle}
      right={<Feedback baseUrl={baseUrl} categories={feedbackCategories} prompt={feedbackPrompt} />}
      hideBackButtonText
      backButtonHref={isPublic ? null : backUrl}
    />
  );
};

Banner.propTypes = {
  backUrl: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  feedbackCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  feedbackPrompt: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  isPublic: PropTypes.bool.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default Banner;
